module.exports = __webpack_public_path__ + "img/ok-yy.57f70a93.png";